import * as React from 'react';

import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

interface PlaybackSubHeadingProps {
  destinationMessage?: string;
  dateRange: string;
  guestCountTitle?: string;
}

export const PlaybackSubHeading: React.FunctionComponent<PlaybackSubHeadingProps> = ({
  destinationMessage,
  dateRange,
  guestCountTitle,
}) => (
  <UitkText align="left" overflow="truncate">
    <UitkText dataTestId="content-location-title" overflow="truncate" size={400} weight="medium">
      {destinationMessage}
    </UitkText>
    <>
      <UitkText dataTestId="playback-date-range" inline={true} size={200} weight="medium">
        {dateRange}
      </UitkText>
      {guestCountTitle && (
        <UitkSpacing padding={{ inline: 'two' }}>
          <UitkText dataTestId="playback-guest-count" inline={true} size={200} weight="medium" aria-label={`, ${guestCountTitle}`}>
            {guestCountTitle}
          </UitkText>
        </UitkSpacing>
      )}
    </>
  </UitkText>
);
